import Auth from './auth/vuex'
// import Packages from './packages/vuex'

export default { Auth }



// WEBPACK FOOTER //
// ./src/app/vuex.js